import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const UserPageWrapper = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full max-w-8xl mx-auto lg:px-10 lg:pt-10 ",
        children: children
    });
};
